/**
 * Port value types. Ports provide access to element properties.
 *
 * - Scalar: a number (side length, angle, area, etc.)
 * - Point: a 2D coordinate [x, y]
 * - Edge: a pair of points defining a line segment
 * - Element: a raw JSXGraph element reference (for glider targets, etc.)
 */

export type ScalarPort = number;
export type PointPort = [number, number];
export interface EdgePort {
  start: [number, number];
  end: [number, number];
}
export type ElementPort = unknown; // JSXGraph GeometryElement

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type PortValue = ScalarPort | PointPort | EdgePort | ElementPort;

/**
 * A port getter returns the current value of a port.
 * For reactive ports (dependent on draggable elements), this function
 * returns different values as the source elements move.
 */
export type PortGetter = () => PortValue;

/**
 * Port map for an element - maps port names to their getter functions.
 *
 * @example
 * // Triangle ports:
 * {
 *   'point.A': () => [0, 0],
 *   'point.B': () => [5, 0],
 *   'a': () => 3.5,
 *   'A': () => 0.785,
 *   'edge.AB': () => ({ start: [0, 0], end: [5, 0] }),
 * }
 */
export type PortMap = Record<string, PortGetter>;
